import Actions from '../../odata/actions';

const actions = new Actions('fringesItem', 'fringesItems');

export default actions;
